import {
    BASE_URL
} from '../../config';
import axios from 'axios';
import {
    CLOSE_BALANCE_MODAL,
    OPEN_BALANCE_MODAL,
    GET_BALANCE_DATA,
    ADD_TRANSACTION,
    RESET_BALANCE,
    CHANGE_DISTRIBUTOR,
    GET_TRANSACTIONS,
    GET_DAILY_TRANSACTIONS,
    SELECT_TRANSACTION,
    DELETE_TRANSACTION,
    GET_MATERIAL_MEANS_REPORT,
    GET_SALARY_TRANSACTIONS,
    ADD_SALARY_TRANSACTIONS,
    DELETE_SALARY_TRANSACTIONS
} from './balance.actionsTypes';
import { loadingAction } from '../../components/loading/loading.action';

import Notifier from '../../components/message/Notifier';

const formatMaxAndMinTime = (params) => {
    params.minDate = new Date(params.minDate).getTime();
    params.maxDate = new Date(params.maxDate).getTime();
    return params;
};

export const getDistributorBalance = (date) => {
    return loadingAction((dispatch, callback) => {
        const params = formatMaxAndMinTime(date);
        axios.get(`${BASE_URL}balance/distributors/`, {
                params
            })
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: GET_BALANCE_DATA,
                        balanceData: response.data
                    });
                    callback();
                }
            });
    });
};

export const openBalanceModal = (distributorId) => {
    if (!distributorId) {
        return;
    }

    return {
        type: OPEN_BALANCE_MODAL,
        distributor: distributorId
    };
};

export const hideBalanceModal = () => {
    return {
        type: CLOSE_BALANCE_MODAL
    };
};

export const getDistributorTransactions = (id, date) => {
    return loadingAction((dispatch, callback) => {
        const params = formatMaxAndMinTime(date);
        axios.get(`${BASE_URL}balance/transactions/${id}`, {
                params
            })
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: GET_TRANSACTIONS,
                        combinedTransactions: response.data
                    });
                    callback();
                }
            });
    });
};

export const getDailyTransactions = (id, type, date, callback) => {
    return (dispatch) => {
        const params = formatMaxAndMinTime(date);
        axios.get(`${BASE_URL}balance/dailyTransactions/${id}/${type}`, {
                params
            })
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: GET_DAILY_TRANSACTIONS,
                        dailyTransactions: response.data.dailyTransactions
                    });
                    callback(response.data);
                }
            });
    };
}

export const getSalaryTransactions = (id, type) => {
    return (dispatch) => {
        axios.get(`${BASE_URL}balance/salaryTransactions/${id}/${type}`)
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: GET_SALARY_TRANSACTIONS,
                        data: {
                            key: id,
                            transactions: response.data
                        } 
                    });
                }
            });
    };
}

export const selectTransaction = (report) => {
    return {
        type: SELECT_TRANSACTION,
        selectedTransaction: report
    };
}

export const createTransaction = (data, callback) => {
    return (dispatch) => {
        axios.post(`${BASE_URL}balance`, data)
            .then((response) => {
                if (response.data && 'function' === typeof callback) {
                    dispatch({
                        type: ADD_TRANSACTION,
                        transaction: response.data.transaction,
                        rest: response.data.rest
                    });
                    callback();
                }
            });
    };
};

export const paySalary = (data, type, callback) => {
    return () => {
        axios.post(`${BASE_URL}balance/paySalary/${type}`, data)
            .then((response) => {
                if (response.data && 'function' === typeof callback) {
                    callback(response.data);
                }
            });
    };
};

export const deleteTransaction = (id, callback) => {
    return (dispatch) => {
        axios.delete(`${BASE_URL}balance/delete/${id}/`)
            .then(() => {
                dispatch({
                    type: DELETE_TRANSACTION
                });
                Notifier.success('_transaction_successfully_deleted_', '_transaction_deleted_');
                if ('function' === typeof callback) {
                    callback();
                }
            });
    };
}

export const changeDistributor = (distributor) => {
    return {
        type: CHANGE_DISTRIBUTOR,
        activeDistributor: distributor
    };
};

export const resetBalance = () => {
    return {
        type: RESET_BALANCE
    };
};

export const addSalaryTransaction = (id,transaction) => {
    return {
        type: ADD_SALARY_TRANSACTIONS,
        data: {
            key: id,
            transaction: transaction
        } 
    };
}; 

export const deleteSalaryTransaction = (id,transactionId) => {
    return {
        type: DELETE_SALARY_TRANSACTIONS,
        data: {
            key: id,
            transactionId
        } 
    };
};

export const getMaterialMeansReport = (date,isSalary = false) => {
    return loadingAction((dispatch, callback) => {
        const params = formatMaxAndMinTime(date);
        axios.get(`${BASE_URL}balance/materialMeansReport/${isSalary}`, {
                params
            })
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: GET_MATERIAL_MEANS_REPORT,
                        materialMeansReport: response.data
                    });
                    callback();
                }
            });
    });
};
